export enum QRData {
  NOT_SCANNED = 'Not scanned'
}
